<template>
  <div>
    <div class="ibox ">
      <div class="ibox-content">
        <form action="" id="postRestrictions">
        <div class="search-form">
          <div class="input-group">
          <div class="search col-lg-12">
            <div class="col-lg-4">
              <div class="col-lg-4"><label for="typePost">Type:</label></div>
              <div class="col-lg-8">
                <div class="col-lg-4">
                  <input type="checkbox" name="type[post]" id="typePost"> Posts
                </div>
                <div class="col-lg-4">
                  <input type="checkbox" name="type[page]" id="typePage"> Pages
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-4"><label for="iLang">Language:</label></div>
              <div class="col-lg-8">
                <select name="language" id="iLang" class="col-lg-8" ref="language"  @change="searchPosts">
                  <option value="">---</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-4"><label for="iTitle">Title:</label></div>
              <div class="col-lg-8">
                <input type="text" name="title" id="iTilte" class="col-lg-8" @keydown.enter="searchPosts">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-4"></div>
              <div class="col-lg-8">
              </div>
            </div>
          </div>
          <div class="search col-lg-12">
            <div class="col-lg-4">
              <div class="col-lg-4"><label for="iRDFrom">RD</label></div>
              <div class="col-lg-8">
                <input type="number" min="0" name="RDFrom" id="iRDFrom" placeholder="from" class="col-lg-4" ref="rdFrom" @keydown.enter="searchPosts">
                <input type="number" min="0" name="RDTo" id="iRDTo" placeholder="to" class="col-lg-4" ref="rdTo" @keydown.enter="searchPosts">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-4"><label for="iTFFrom">TF</label></div>
              <div class="col-lg-8">
                <input type="number" min="0" name="TFFrom" id="iTFFrom" placeholder="from" class="col-lg-4" ref="tfFrom" @keydown.enter="searchPosts">
                <input type="number" min="0" name="TFTo" id="iTFTo" placeholder="to" class="col-lg-4" ref="tfTo" @keydown.enter="searchPosts">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-4"><label for="iDAFrom">DA</label></div>
              <div class="col-lg-8">
                <input type="number" min="0" name="DAFrom" id="iDAFrom" placeholder="from" class="col-lg-4" ref="daFrom" @keydown.enter="searchPosts">
                <input type="number" min="0" name="DATo" id="iDATo" placeholder="to" class="col-lg-4" ref="daTo" @keydown.enter="searchPosts">
              </div>
            </div>
          </div>
          </div>
        </div>
        </form>
        <div class="search-form mt-2">
          <div class="input-group">
            <input type="text" placeholder="Find posts..." name="search" v-model="searchTerm" class="form-control form-control-lg" @keydown.enter="searchPosts">
            <div class="input-group-btn">
              <button class="btn btn-md btn-primary" type="submit" @click="searchPosts">
                Search
              </button>
            </div>
          </div>
        </div>
        <div class="hr-line-dashed"></div>
        <h2 v-if="postsLoaded">
          {{ searchResultCount }} results found for: <span class="text-navy">“{{ searchedTerm }}”</span>
        </h2>
        <postList></postList>
      </div>
    </div>
  </div>
</template>

<script>
import postList from '../Site/PostList'
import axios from 'axios'
import { eventBus } from '../../../main'

export default {
  name: 'Search',
  data () {
    return {
      postsLoaded: false,
      searchTerm: '',
      searchedTerm: '',
      searchResultCount: 0
    }
  },
  components: {
    postList: postList
  },
  mounted () {
    this.getLangs()
  },
  methods: {
    getLangs () {
      axios.get(process.env.API + '/languages').then(response => {
        for (let key in response.data.data) {
          this.$refs.language.add(new Option(response.data.data[key], key))
        }
      })
    },
    searchPosts () {
      axios.get(process.env.API + '/find-post?query=' + this.searchTerm + '&' + $('#postRestrictions').serialize())
        .then(response => {
          this.posts = response.data
          this.postsLoaded = true
          this.searchResultCount = this.posts.length
          this.searchedTerm = this.searchTerm
          eventBus.$emit('postList', response.data)
        }).catch(e => {
          this.postsLoaded = false
          console.log(e)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pages/Posts/Search.vue